import { Link } from "react-router-dom";
import type { Episode } from "@/types/content";

export default function EpisodeCard({ episode }: { episode: Episode }) {
  return (
    <Link
      to={`/detail/episode/${episode.id}`}
      className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 cursor-pointer transition-colors hover:border-primary-300"
    >
      <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-200">
        <img
          src={episode.cover}
          alt={`${episode.title} 剧照`}
          title={`继母的诱惑 第${episode.number}集 ${episode.title}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 rounded-md bg-primary-950/80 text-background-50 text-xs px-2.5 py-1">
          第 {episode.number} 集
        </span>
        <span className="absolute top-3 right-3 rounded-md bg-accent-500/90 text-primary-950 text-xs px-2.5 py-1">
          S{episode.season}
        </span>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
          {episode.title}
        </h3>
        <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {episode.airDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-user-line" />
            {episode.characterIds.length} 位角色
          </span>
        </div>
        <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {episode.summary}
        </p>
      </div>
    </Link>
  );
}